<template>
  <div data-tab-name="Templates" class="w-full">
    <div class="aha-nav-button-container">
      <aha-nav-button
        class="w-full"
        name="right_nav_button"
        v-aha-emit-action="{ user_input: 'Templates' }"
        @click="handleClick()"

        :active="false"
        iconName="phosphor-MagicWand"
        :icon-width="24"
        :icon-height="24"

        :label="$i18nPresenter.t('Templates')"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TemplateLibraryTrigger',
  methods: {
    ...mapActions(['setShowModalTemplateLibraryAction']),
    handleClick() {
      this.setShowModalTemplateLibraryAction(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.aha-nav-button-container {
  @apply my-0 mx-1 mb-2;
}
</style>
